import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 🔹 Interceptor para agregar automáticamente el token en cada petición
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🔹 Interceptor para manejar tokens expirados
api.interceptors.response.use(
    response => response,
    async (error) => {
        if (error.response?.status === 401) {
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (!refreshToken) {
                    console.warn("No refresh token available, redirecting to login");
                    localStorage.clear();
                    window.location.href = '/login';
                    return Promise.reject(error);
                }

                const response = await axios.post(`${apiUrl}/api/auth/refresh-token`, { refreshToken });
                const { accessToken, refreshToken: newRefreshToken } = response.data;

                localStorage.setItem('authToken', accessToken);
                localStorage.setItem('refreshToken', newRefreshToken);

                // 🔹 Reintentar la petición original con el nuevo token
                error.config.headers['Authorization'] = `Bearer ${accessToken}`;
                return api.request(error.config);
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                localStorage.clear();
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
